import WebServices from './WebServices';
import Activity from './Activity';
import {POS_POLL_URL, POS_SALE_URL} from '../config/App';

export default class POSAPI {
    static poll = () => {
        return fetch(POS_POLL_URL, {method: 'POST', mode: 'cors', cache: 'no-cache', headers: {'Content-Type': 'application/json'}, signal: AbortSignal.timeout(3000)})
            .then(response => WebServices.onResponse(response))
            .then(response => {
                if (response) return response.status;
                else return false;
            })
            .catch(() => {
                return false;
            });
    };

    static sale = (metadata, amount, ticket, print, timeout, signal) => {
        return new Promise((resolve) => {
            if (ticket && ticket.length > 10) ticket = ticket.substring(0, 10);
            const body = {Amount: amount, Ticket: ticket, Print: print ? 1 : 0};
            Activity.log(metadata, 'checkout', 'pos-sale', 'start', true, body);
            return fetch(POS_SALE_URL, {method: 'POST', mode: 'cors', cache: 'no-cache', headers: {'Content-Type': 'application/json'}, signal: signal, body: JSON.stringify(body)})
                .then(response => WebServices.onResponse(response))
                .then(response => {
                    Activity.log(metadata, 'checkout', 'pos-sale', 'finish', true, response);
                    setTimeout(() => {
                        if (response) {
                            response["cardType"] = response["cardType"] || "DB"; // CR for "credit" or DB for "debit". Fallback case will be "debit".
                            resolve(response);
                        } else resolve(undefined);
                    }, 1000 * timeout);
                })
                .catch(() => {
                    resolve(undefined);
                });
        });
    };
}